var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filePond"},[_c('file-pond',{ref:"pond",attrs:{"name":"filepond","label-idle":_vm.title,"allow-multiple":_vm.allowMultiple,"accepted-file-types":"image/*","server":_vm.server},on:{"init":_vm.handleFilePondInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }